import { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { api, errorLine } from './api/client';
import type { Me } from './api/types';
import { NavRail } from './components/nav-rail';
import { OrgRoute } from './routes/org';
import { Orgs } from './routes/orgs';
import { Demos } from './routes/orgs/demos';

/** Operator organization management and the explicit, versioned demo lifecycle. */
export function App() {
  const [me, setMe] = useState<Me | null>(null);
  const [meError, setMeError] = useState<string | null>(null);

  useEffect(() => {
    api
      .me()
      .then(setMe)
      .catch((caught: unknown) => setMeError(errorLine(caught)));
  }, []);

  return (
    <>
      <NavRail me={me} />
      <main className="main">
        <div className="column">
          {meError ? (
            <div className="flag row">
              <div className="label">Not signed in</div>
              <div className="detail">{meError}</div>
            </div>
          ) : null}

          <Routes>
            <Route path="/" element={<Orgs />} />
            <Route path="/demos" element={<Demos />} />
            {/* Not a screen — where Auth0 is allowed to send a code back to
                (env.ts). The provider has restored the address by the time the
                router mounts, so this only catches a reload of `/callback` with
                a live session and nothing to exchange. */}
            <Route path="/callback" element={<Navigate to="/" replace />} />
            <Route path="/organizations/:orgId" element={<OrgRoute />} />
            <Route path="/organizations/:orgId/:tab" element={<OrgRoute />} />
            {/* An address this app does not have is the list, not a blank
                column: there is one other page and it needs an id. */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </main>
    </>
  );
}
